export default __webpack_public_path__ + "static/media/flaskEmpty.55c5e5e6.svg";